'use client'

import { cn } from '@/lib/utils'

/**
 * <main> wrapper for the (pub) route group. Zero-padding, full-width: each
 * v2 primitive (V2Hero, V2Section, V2CtaBand, AppFooter) already owns its
 * own full-bleed background plus an inner `mx-auto max-w-[1200px] px-6`
 * content column, so the outer container only needs to get out of the way.
 */
export function PubMain({ children }: { children: React.ReactNode }) {
  return (
    <main
      className={cn(
        'relative grow w-full pb-[calc(var(--app-bottom-nav-h,72px)+env(safe-area-inset-bottom,0px))] md:pb-4',
        'bg-background'
      )}
    >
      {children}
    </main>
  )
}
